// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AmbientVideoController from "./ambient_video_controller"
application.register("ambient-video", AmbientVideoController)

import BatchFaqController from "./batch_faq_controller"
application.register("batch-faq", BatchFaqController)

import CaptionGeneratorController from "./caption_generator_controller"
application.register("caption-generator", CaptionGeneratorController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorwayFilterController from "./colorway_filter_controller"
application.register("colorway-filter", ColorwayFilterController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import IndiePatternSelectController from "./indie_pattern_select_controller"
application.register("indie-pattern-select", IndiePatternSelectController)

import LazyDetailsController from "./lazy_details_controller"
application.register("lazy-details", LazyDetailsController)

import MediaFilterController from "./media_filter_controller"
application.register("media-filter", MediaFilterController)

import PanelRefreshController from "./panel_refresh_controller"
application.register("panel-refresh", PanelRefreshController)

import PinnedRunController from "./pinned_run_controller"
application.register("pinned-run", PinnedRunController)

import PostActionController from "./post_action_controller"
application.register("post-action", PostActionController)

import PostComposerController from "./post_composer_controller"
application.register("post-composer", PostComposerController)

import PsdUploadController from "./psd_upload_controller"
application.register("psd-upload", PsdUploadController)

import RecordPickerController from "./record_picker_controller"
application.register("record-picker", RecordPickerController)

import VisionCardController from "./vision_card_controller"
application.register("vision-card", VisionCardController)
